import React, { useState, useEffect } from "react";

const cities = [
  { id: 1, name: "Austin", basePrice: 9.92 },
  { id: 2, name: "Miami", basePrice: 9.92 },
  { id: 3, name: "Gainesville", basePrice: 9.95 },
  { id: 4, name: "Jacksonville", basePrice: 9.95 },
  { id: 5, name: "Tampa", basePrice: 9.95 },
  { id: 6, name: "St. Petersburg", basePrice: 9.95 },
  { id: 7, name: "Orlando", basePrice: 9.95 },
  { id: 8, name: "St. Louis", basePrice: 9.95 },
  { id: 9, name: "DFW", basePrice: 9.95 },
  { id: 10, name: "Clearwater", basePrice: 9.95 },
];

const Pricing = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [openCity, setOpenCity] = useState(null);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleCity = (id) => {
    setOpenCity(openCity === id ? null : id);
  };

  return (
    <div
      style={{
        ...styles.container,
        paddingTop: isMobile ? "6rem" : "2rem",
      }}
    >
      <h1 style={styles.header}>Cities Base Price</h1>

      <div style={styles.grid}>
        {cities.map((city) => (
          <div
            key={city.id}
            style={{
              ...styles.card,
              border:
                openCity === city.id ? "2px solid #fd5c63" : "2px solid transparent",
            }}
            onClick={() => toggleCity(city.id)}
          >
            <h2 style={styles.cityName}>{city.name}</h2>
            <p style={styles.summaryText}>
              Click to view base fare & Berymo Rider details
            </p>

            {/* Smooth dropdown */}
            <div
              style={{
                ...styles.dropdown,
                maxHeight: openCity === city.id ? "200px" : "0px",
                padding: openCity === city.id ? "1rem" : "0rem",
              }}
            >
              <p style={styles.price}>Base Price: ${city.basePrice.toFixed(2)}</p>

              <p style={styles.riderInfo}>
                <strong>Berymo Rider:</strong> Enjoy fast, reliable and affordable
                rides in {city.name}. All fares include safety, quality checks, and
                real-time tracking for the best passenger experience.
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

const styles = {
  container: {
    padding: "2rem",
    fontFamily: "Arial, sans-serif",
    backgroundColor: "#f9f9f9",
    minHeight: "100vh",
  },
  header: {
    textAlign: "center",
    marginBottom: "2rem",
    color: "#333",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))",
    gap: "1.5rem",
  },
  card: {
    backgroundColor: "#FEF4F5",
    padding: "1rem",
    borderRadius: "12px",
    boxShadow: "0 4px 6px rgba(0,0,0,0.08)",
    cursor: "pointer",
    transition: "0.3s",
  },
  cityName: {
    fontSize: "1.3rem",
    marginBottom: "0.3rem",
    color: "#fd5c63",
  },
  summaryText: {
    fontSize: "0.9rem",
    color: "#444",
  },
  dropdown: {
    overflow: "hidden",
    transition: "all 0.35s ease",
    backgroundColor: "#fff",
    borderRadius: "10px",
    marginTop: "1rem",
  },
  price: {
    fontSize: "1.1rem",
    fontWeight: "bold",
    color: "#333",
    marginBottom: "0.5rem",
  },
  riderInfo: {
    fontSize: "0.9rem",
    color: "#555",
    lineHeight: "1.4",
  },
};

export default Pricing;
